import {
  Box,
  Button,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core";
import ConfirmDelete from "components/ConfirmDelete";
import { ListItemAccordion } from "components/List/StyledComponents";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { getFormattedTimeStamp } from "utils/dateUtils";
import CertTypeChip from "../CertTypeChip";
import Details from "./Details";
import { useState } from "react";
import { SmimeCert } from "@dashboard-v3/api";

type Params = {
  certificate: SmimeCert;
  onDelete: () => void;
};

export default function PmimeCert({ certificate, onDelete }: Params) {
  const { t } = useTranslation("smime");

  const [showDetails, setShowDetails] = useState(false);

  return (
    <ListItem disableGutters>
      <ListItemAccordion style={{ padding: "12px 16px" }}>
        <ContentContainer>
          <ListItemText
            primary={
              <Box display="flex" alignItems="center">
                <Typography
                  display="inline"
                  style={{ marginRight: "10px", fontWeight: "500" }}
                >
                  {certificate.friendlyName}
                </Typography>

                <CertTypeChip cert={certificate} />
              </Box>
            }
            secondary={
              <Box
                marginTop="12px"
                gridGap="5px"
                display="flex"
                flexDirection="column"
              >
                {certificate.description && (
                  <Box mb="15px">
                    <Typography
                      color="textSecondary"
                      display="inline"
                      variant="body2"
                    >
                      {certificate.description}
                    </Typography>
                  </Box>
                )}

                <Typography color="textSecondary" variant="body2">
                  {t("item.uploadedOn", {
                    date: getFormattedTimeStamp(certificate.updatedAt, true),
                  })}
                </Typography>
              </Box>
            }
          />
          <ActionButtons>
            <Box display="flex" gridGap=".8rem">
              <Box>
                <Button variant="outlined" onClick={() => setShowDetails(true)}>
                  {t("item.details")}
                </Button>
              </Box>
              {onDelete && (
                <ConfirmDelete
                  variant="outlined"
                  size="small"
                  message={
                    <>
                      <Box mb={1}>
                        <Typography variant="body1" color="textPrimary">
                          {t("delete.msg", { name: certificate.friendlyName })}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="textSecondary">
                        {t("delete.warning")}
                      </Typography>
                    </>
                  }
                  style={{ marginLeft: "10px" }}
                  onAccept={onDelete}
                />
              )}
            </Box>
          </ActionButtons>
        </ContentContainer>
      </ListItemAccordion>
      <Details
        cert={certificate}
        open={showDetails}
        onClose={() => setShowDetails(false)}
      />
    </ListItem>
  );
}

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 15px;
`;

const ActionButtons = styled.div`
  align-self: center;
  margin-right: 20px;
`;
